import React from 'react'

import { useSelect } from 'store/index'

import ResignedListingCard from 'components/Favorites/FavoritesPage/Cards/ResignedListingCard'

import style from './FavoritesGrid.module.scss'

const ResignedGrid: React.FC = () => {
  const resignedListingData = useSelect(
    (state) => state.favorites.resignedListingData,
  )

  return (
    <div
      className={`${style.resultsGrid} ${style.favoritesGrid} ${style.resignedGrid}`}
    >
      <div className={style.resignedListings}>
        <h3 className={style.unavailableHeader}>Unavailable</h3>
        <p>
          These homes have been removed from the Evolve network and are no
          longer available to rent.
        </p>
        {resignedListingData.map((listing) => (
          <ResignedListingCard
            isFaded={listing.shouldRemoveData ?? false}
            key={listing.objectID}
            listing={listing}
          />
        ))}
      </div>
    </div>
  )
}
export default ResignedGrid
